(function () {
  'use strict';

  /* ── Shopify data bridge ──────────────────────────────────────── */
  const shopify = window.__JB_CUSTOMIZER__ || {};

  /* ── Hardcoded fallback data ──────────────────────────────────── */
  const FALLBACK_FABRIC_COLORS = [
    { id: 'white',      color: '#FDFDFB', name: 'White' },
    { id: 'ivory',      color: '#F5F5F0', name: 'Ivory' },
    { id: 'champagne',  color: '#F0E6D2', name: 'Champagne' },
    { id: 'charcoal',   color: '#4A4A4A', name: 'Charcoal' },
    { id: 'navy',       color: '#1E2B4D', name: 'Navy' },
  ];

  const FALLBACK_EMBROIDERY_COLORS = [
    { id: 'white-emb',    color: '#FDFDFB', name: 'White' },
    { id: 'black-emb',    color: '#353535', name: 'Black' },
    { id: 'navy-emb',     color: '#1E2B4D', name: 'Navy' },
    { id: 'gold-emb',     color: '#D4A745', name: 'Gold' },
  ];

  const FALLBACK_MONOGRAM_COLORS = [
    { id: 'ivory',   name: 'Ivory',   color: '#F5F5DC' },
    { id: 'white',   name: 'White',   color: '#FFFFFF' },
    { id: 'ecru',    name: 'Ecru',    color: '#C2B280' },
    { id: 'navy',    name: 'Navy',    color: '#000080' },
    { id: 'black',   name: 'Black',   color: '#000000' },
    { id: 'gold',    name: 'Gold',    color: '#FFD700' },
  ];

  /* Same 4 recommended styles used on Bedding and Table Linens */
  const FALLBACK_RECOMMENDED = [
    { id: 'C14', name: 'C14', placeholder: '', max: 3, colorQty: 2, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/C14.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/C14_em.png' },
    { id: 'A56', name: 'A56', placeholder: '', max: 3, colorQty: 1, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A56.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A56_em.png' },
    { id: 'A61', name: 'A61', placeholder: '', max: 1, colorQty: 2, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A61.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A61_em.png' },
    { id: 'A11', name: 'A11', placeholder: '', max: 3, colorQty: 1, image: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A11.png', hoverImage: 'https://cdn.shopify.com/s/files/1/0261/5715/4350/files/A11_em.png' },
  ];

  const FALLBACK_CLASSIC = [
    { id: 'C01', name: 'C01', placeholder: 'S'   }, { id: 'C02', name: 'C02', placeholder: 'GA'  },
    { id: 'C03', name: 'C03', placeholder: 'JKL' }, { id: 'C04', name: 'C04', placeholder: 'L'   },
    { id: 'C05', name: 'C05', placeholder: 'OG'  }, { id: 'C06', name: 'C06', placeholder: 'NG'  },
    { id: 'C07', name: 'C07', placeholder: 'MMS' }, { id: 'C08', name: 'C08', placeholder: 'JB'  },
    { id: 'C09', name: 'C09', placeholder: 'A'   }, { id: 'C10', name: 'C10', placeholder: 'O'   },
    { id: 'C11', name: 'C11', placeholder: 'A'   }, { id: 'C12', name: 'C12', placeholder: 'M'   },
  ];

  const FALLBACK_CONTEMPORARY = [
    { id: 'M01', name: 'M01', placeholder: 'GG' }, { id: 'M02', name: 'M02', placeholder: 'M'  },
    { id: 'M03', name: 'M03', placeholder: 'ET' }, { id: 'M04', name: 'M04', placeholder: 'ER' },
    { id: 'M05', name: 'M05', placeholder: 'RF' }, { id: 'M06', name: 'M06', placeholder: 'CL' },
    { id: 'M07', name: 'M07', placeholder: 'SD' }, { id: 'M08', name: 'M08', placeholder: 'JP' },
    { id: 'M09', name: 'M09', placeholder: 'HH' }, { id: 'M10', name: 'M10', placeholder: '*'  },
    { id: 'M11', name: 'M11', placeholder: 'A'  }, { id: 'M12', name: 'M12', placeholder: 'K'  },
  ];

  const FALLBACK_CHILDREN = [
    { id: 'K01', name: "K01 Children's", placeholder: 'ET'  }, { id: 'K02', name: "K02 Children's", placeholder: 'M'   },
    { id: 'K03', name: "K03 Children's", placeholder: 'SS'  }, { id: 'K04', name: "K04 Children's", placeholder: 'N'   },
    { id: 'K05', name: "K05 Children's", placeholder: 'ESB' }, { id: 'K06', name: "K06 Children's", placeholder: 'S'   },
    { id: 'K07', name: "K07 Children's", placeholder: 'JP'  }, { id: 'K08', name: "K08 Children's", placeholder: 'PL'  },
  ];

  const FALLBACK_POSITIONS = [
    { location: 'Center',              image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Sham_Monogram_-_Center.avif' },
    { location: 'Top Center',          image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Sham_Monogram_-_Top_Center.avif' },
    { location: 'Angled Right Corner', image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Shams_Angled_Right_Corner.jpg?v=1693581469' },
    { location: 'Angled Left Corner',  image: 'https://cdn.shopify.com/s/files/1/0660/2283/4419/files/Shams_Angled_Left_Corner.jpg' },
  ];

  /* ── Data transformation helpers (shared shape with bedding/table linens customizers) ── */

  function buildFabricColorsFromShopify(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map((c, i) => ({ id: 'f' + i, color: c.hex || '#FDFDFB', name: c.label || ('Color ' + (i + 1)) }));
  }

  function buildEmbroideryColorsFromShopify(raw, prefix) {
    if (!Array.isArray(raw) || !raw.length) return null;
    const p = prefix || 'e';
    return raw.map((c, i) => ({ id: p + i, color: c.hex || c.hex2 || '#353535', name: c.label || ('Color ' + (i + 1)) }));
  }

  function buildMonogramColors(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map((c, i) => ({ id: 'mc' + i, color: c.hex || '#CCCCCC', name: c.label || ('Color ' + (i + 1)) }));
  }

  function buildHeroImages(raw) {
    if (!raw) return null;
    const arr = Array.isArray(raw) ? raw : (typeof raw === 'object' && raw.images ? raw.images : [raw]);
    const mapped = arr
      .filter(img => !img.media_type || img.media_type === 'image')
      .map(img => ({
        src: img.src || img.url || img.image || (img.preview_image && img.preview_image.src) || (typeof img === 'string' ? img : ''),
        src2x: img.src2x || '',
        caption: img.caption || img.alt || img.title || '',
        ratio: img.ratio || 1,
        width: img.width || 0,
        height: img.height || 0,
      }))
      .filter(img => img.src);
    return mapped.length ? mapped : null;
  }

  function buildMonogramStyles(data) {
    if (!data) return null;
    if (Array.isArray(data)) {
      if (!data.length) return null;
      const byType = {};
      data.forEach(s => {
        const t = s.type || 'classic';
        if (!byType[t]) byType[t] = [];
        byType[t].push({
          id: s.id, name: s.name || s.id, image: s.img1 || '', hoverImage: s.img2 || s.img1 || '',
          placeholder: '', max: s.max || 3, colorQty: parseInt(s.c_QTY, 10) || 1,
        });
      });
      return byType;
    }
    if (typeof data === 'string') return null;
    return data;
  }

  function getMonogramStyleTab(styles, key) {
    if (!styles) return null;
    const arr = styles[key] || styles[key + 's'];
    return Array.isArray(arr) && arr.length ? arr : null;
  }

  function buildMonogramPositions(raw) {
    if (!Array.isArray(raw) || !raw.length) return null;
    return raw.map(p => ({
      location: p.location || p.name || p.label || '',
      image: p.image_url || p.image || p.src || p.img || '',
      product_type_id: p.product_type_id != null ? parseInt(p.product_type_id, 10) : null,
    }));
  }

  function formatPrice(cents, currency) {
    const syms = { EUR: '€', USD: '$', GBP: '£', CAD: 'CA$', AUD: 'A$', CHF: 'CHF ' };
    return (syms[currency] || (currency + ' ')) + (cents / 100).toFixed(2);
  }

  function getVariantOptionVal(v, idx) {
    if (idx === 0) return v.o1 || '';
    if (idx === 1) return v.o2 || '';
    if (idx === 2) return v.o3 || '';
    return '';
  }

  /* Bath has no fabric-tier concept (no Pure Bliss) — fabric types are read straight off the
     variant option values with no display-name remapping, and shown only when a product
     actually has more than one fabric (dynamic, not a fixed step). */
  function buildProducts(rawProducts, defaultColorInfo, currency) {
    if (!Array.isArray(rawProducts) || !rawProducts.length) return null;
    return rawProducts.map(p => {
      const typeNum = parseInt(p.type, 10);
      /* Per-product monogram_variant_id metafield wins; otherwise fall back to the shared
         default monogram variant (monogram-bath) — same pattern as _buildLineItems below. */
      const hasMonogram = !!(p.monogramVariantId || monogramDefaultVariantId);

      const options = Array.isArray(p.options) ? p.options : [];
      const variants = Array.isArray(p.variants) ? p.variants : [];

      const fabricOptIdx = options.findIndex(o => /base.?fabric|fabric/i.test(o));
      const sizeOptIdx = options.findIndex(o => /size/i.test(o));

      const sizes = [];
      if (sizeOptIdx >= 0) {
        const seen = new Set();
        for (const v of variants) {
          const sz = getVariantOptionVal(v, sizeOptIdx);
          if (sz && !seen.has(sz)) { seen.add(sz); sizes.push(sz); }
        }
      }

      const fabricTypes = [];
      if (fabricOptIdx >= 0) {
        const seen = new Set();
        for (const v of variants) {
          const f = getVariantOptionVal(v, fabricOptIdx);
          if (f && !seen.has(f)) { seen.add(f); fabricTypes.push(f); }
        }
      }

      const img = (p.image || '');

      return makeProduct({
        key: 'item' + (p.id || ''),
        typeNum,
        title: p.title,
        image: img.startsWith('//') ? 'https:' + img : img,
        unitPriceCents: p.price,
        price: formatPrice(p.price, currency),
        shopifyId: p.id,
        variantId: p.variantId,
        monogramVariantId: p.monogramVariantId || null,
        tags: Array.isArray(p.tags) ? p.tags : [],
        hasMonogram,
        fabricTypes,
        sizes,
        size: sizes[0] || '',
        fabricType: fabricTypes[0] || '',
        customColorInfo: { ...defaultColorInfo },
        variantData: variants,
        fabricOptIdx,
        sizeOptIdx,
      });
    });
  }

  /* ── makeProduct helper ───────────────────────────────────────── */
  function makeProduct(cfg) {
    return Object.assign({
      /* Colors are always "custom" for bath — there is no recommended-combo step to fall
         back to, so colorChosen is true from the start and customColorInfo is pre-populated
         by the caller (buildProducts / FALLBACK_PRODUCTS) with the first available colors.
         colorEdited tracks whether the shopper has actually opened the color picker and
         confirmed a choice — the card shows a "pick your colors" CTA until then, rather
         than presenting the silent default as if it were already their selection. */
      colorChosen: true,
      colorEdited: false,
      customColorInfo: null,
      variantAvailable: true,
      quantity: 1,
      monogram: false,
      monogramSelection: null,
      message: '',
      initials: '',
      initial: '',
      customRequest: '',
      bdayName: '',
      bdayDay: '',
      bdayMonth: '',
      bdayYear: '',
    }, cfg);
  }

  /* ── Build runtime data from Shopify or fallbacks ────────────── */
  const fabricColors = buildFabricColorsFromShopify(shopify.fabricColors) || FALLBACK_FABRIC_COLORS;
  const embroideryColors = buildEmbroideryColorsFromShopify(shopify.embroideryColors, 'e') || FALLBACK_EMBROIDERY_COLORS;
  const embroidery2Colors = buildEmbroideryColorsFromShopify(shopify.embroidery2Colors, 'e2') || [];
  const appliqueColors = buildEmbroideryColorsFromShopify(shopify.appliqueColors, 'a') || [];
  const applique2Colors = buildEmbroideryColorsFromShopify(shopify.applique2Colors, 'a2') || [];

  const customRequestDefault = shopify.customRequestDefault || "Can't find exactly what you're looking for? At Julia B. Casa, we delight in tailoring linens to your wishes — simply let us know what you need.";
  const customRequestMessages = shopify.customRequestMessages || {};

  const embroidery_exists = !!shopify.embroidery_exists;
  const embroidery2_exists = !!shopify.embroidery2_exists;
  const applique_exists = !!shopify.applique_exists;
  const applique2_exists = !!shopify.applique2_exists;
  const embroideryLabel = shopify.embroideryLabel || 'Embroidery';
  const embroidery2Label = shopify.embroidery2Label || 'Secondary Embroidery';
  const _accentApplique = s => s.replace(/Applique\b/g, 'Appliqué').replace(/applique\b/g, 'appliqué');
  const appliqueLabel = _accentApplique(shopify.appliqueLabel || 'Appliqué');
  const applique2Label = _accentApplique(shopify.applique2Label || 'Second Appliqué');
  const heroImgs = buildHeroImages(shopify.heroImages);
  const bundleImgs = buildHeroImages(shopify.bundleImages);
  const monoData = shopify.monogramData;
  const monoStylesAll = buildMonogramStyles(Array.isArray(monoData) ? monoData : null);
  const classicStyles = (monoStylesAll && monoStylesAll.classic) || getMonogramStyleTab(monoData, 'classic') || FALLBACK_CLASSIC;
  const contemporaryStyles = (monoStylesAll && monoStylesAll.contemporary) || getMonogramStyleTab(monoData, 'contemporary') || FALLBACK_CONTEMPORARY;
  const childrenStyles = (monoStylesAll && (monoStylesAll.children || monoStylesAll.childrens)) || getMonogramStyleTab(monoData, 'childrens') || getMonogramStyleTab(monoData, 'children') || FALLBACK_CHILDREN;
  const allMonogramPositions = buildMonogramPositions(shopify.monogramPositions) || FALLBACK_POSITIONS;
  const currency = shopify.currency || 'EUR';
  /* monogram-bath (not monogram-1) — bath's own default monogram variant. Per-product wins
     when a customizer-product-data.monogram_variant_id metafield is set. */
  const monogramDefaultVariantId = shopify.monogramDefaultVariantId || null;

  /* Every product starts with a real color already chosen — first fabric/embroidery/appliqué
     color in each enabled layer — since bath skips the recommended-combo step entirely. */
  const DEFAULT_COLOR_INFO = {
    fabricColor: (fabricColors[0] || {}).color || '#FDFDFB',
    fabricName: (fabricColors[0] || {}).name || '',
    embroideryColor: embroidery_exists && embroideryColors[0] ? embroideryColors[0].color : null,
    embroideryName: embroidery_exists && embroideryColors[0] ? embroideryColors[0].name : null,
    embroidery2Color: embroidery2_exists && embroidery2Colors[0] ? embroidery2Colors[0].color : null,
    embroidery2Name: embroidery2_exists && embroidery2Colors[0] ? embroidery2Colors[0].name : null,
    appliqueColor: applique_exists && appliqueColors[0] ? appliqueColors[0].color : null,
    appliqueName: applique_exists && appliqueColors[0] ? appliqueColors[0].name : null,
    applique2Color: applique2_exists && applique2Colors[0] ? applique2Colors[0].color : null,
    applique2Name: applique2_exists && applique2Colors[0] ? applique2Colors[0].name : null,
  };

  /* Array.isArray (not just truthiness) matters here: an empty array means Liquid genuinely
     tried to load this bundle's products and found none (e.g. the mb-<handle> collection isn't
     published to the Online Store channel, or no products carry customizer-product-data) — that
     should show an honest empty state, never the FALLBACK_PRODUCTS demo photos. Those demo
     photos are only appropriate when shopify.products is missing entirely (local/no-bridge dev). */
  const hasShopifyProductsData = Array.isArray(shopify.products);
  const shopifyProducts = hasShopifyProductsData ? buildProducts(shopify.products, DEFAULT_COLOR_INFO, currency) : null;

  /* ── Fallback products (local dev / no Shopify data) ─────────── */
  const FALLBACK_PRODUCTS = [
    makeProduct({
      key: 'bathtowel', title: 'Bath Towel',
      image: 'https://juliab.com/cdn/shop/files/Letto_Calais_600x600.jpg',
      price: '€89.95', hasMonogram: true,
      fabricTypes: [], fabricType: '',
      sizes: ['30" x 56"'], size: '30" x 56"',
      customColorInfo: { ...DEFAULT_COLOR_INFO },
    }),
    makeProduct({
      key: 'bathrobe', title: 'Bathrobe',
      image: 'https://juliab.com/cdn/shop/files/Letto_Calais_600x600.jpg',
      price: '€249.95', hasMonogram: true,
      fabricTypes: [], fabricType: '',
      sizes: ['S/M', 'L/XL'], size: 'S/M',
      customColorInfo: { ...DEFAULT_COLOR_INFO },
    }),
    makeProduct({
      key: 'bathmat', title: 'Bath Mat',
      image: 'https://juliab.com/cdn/shop/files/Letto_Calais_600x600.jpg',
      price: '€69.95', hasMonogram: false,
      fabricTypes: [], fabricType: '',
      sizes: ['21" x 34"'], size: '21" x 34"',
      customColorInfo: { ...DEFAULT_COLOR_INFO },
    }),
  ];

  /* ── Vue 3 App ────────────────────────────────────────────────── */
  const app = Vue.createApp({
    delimiters: ['${', '}'],

    data() {
      return {
        heroSlide: 0,
        bundleSlide: 0,
        aboutSlide: 0,
        /* Same as Bedding/Table Linens: the very first color choice made anywhere in the
           bundle is applied to every product, on the assumption the shopper wants a matching
           set by default. Later edits only affect the product being edited. */
        isFirstSelection: true,

        heroImages: heroImgs || [{ src: '/hero-image.jpg', caption: shopify.productTitle || 'Julia B. Casa Collection' }],
        bundleImages: bundleImgs || heroImgs || [{ src: '/hero-image.jpg', caption: shopify.productTitle || 'Julia B. Casa Collection' }],

        fabricColors, embroideryColors, embroidery2Colors, appliqueColors, applique2Colors,
        embroidery_exists, embroidery2_exists, applique_exists, applique2_exists,
        customRequestDefault, customRequestMessages,
        embroideryLabel, embroidery2Label, appliqueLabel, applique2Label,
        monogramColors: buildMonogramColors(shopify.monogramColors) || FALLBACK_MONOGRAM_COLORS,
        recommendedStyles: (monoStylesAll && monoStylesAll.recommended) || getMonogramStyleTab(monoData, 'recommended') || FALLBACK_RECOMMENDED,
        classicStyles, contemporaryStyles, childrenStyles,
        monogramPositionImages: allMonogramPositions,

        products: shopifyProducts || (hasShopifyProductsData ? [] : FALLBACK_PRODUCTS),

        monogramPriceCents: shopify.monogramPriceCents || 0,
        cartLoading: false,
        cartDrawer: { isOpen: false, loading: false, items: [], itemCount: 0, total: '' },

        svgMain: null,

        colorModal: {
          isOpen: false, productIdx: null,
          selectedFabric: 'f0', selectedEmbroidery: 'e0', selectedEmbroidery2: 'e20',
          selectedApplique: 'a0', selectedApplique2: 'a20',
          showAllFabric: false, showAllEmbroidery: false, showAllEmbroidery2: false,
          showAllApplique: false, showAllApplique2: false,
        },

        monogramModal: {
          isOpen: false, productIdx: null, currentStep: 1,
          showAllStyles: false, activeTab: 'classic', activeLetterCount: 1,
          hoveredStyleId: null, showAllLetterColors: false, showAllDetailColors: false,
          selection: { styleId: null, styleName: '', styleImage: '', styleHoverImage: '', stylePlaceholder: '', letters: '', sleepingLetterColor: 'ecru', sleepingDetailColor: 'ecru', location: '' },
        },
      };
    },

    computed: {
      visibleFabricColors() { return this.colorModal.showAllFabric ? this.fabricColors : this.fabricColors.slice(0, 6); },
      visibleEmbroideryColors() { return this.colorModal.showAllEmbroidery ? this.embroideryColors : this.embroideryColors.slice(0, 6); },
      visibleEmbroidery2Colors() { return this.colorModal.showAllEmbroidery2 ? this.embroidery2Colors : this.embroidery2Colors.slice(0, 6); },
      visibleAppliqueColors() { return this.colorModal.showAllApplique ? this.appliqueColors : this.appliqueColors.slice(0, 6); },
      visibleApplique2Colors() { return this.colorModal.showAllApplique2 ? this.applique2Colors : this.applique2Colors.slice(0, 6); },
      selectedFabricHex() { const c = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric); return c ? c.color : '#FDFDFB'; },
      selectedEmbroideryHex() { const c = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery); return c ? c.color : '#353535'; },
      selectedEmbroidery2Hex() { const c = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2); return c ? c.color : '#353535'; },
      selectedAppliqueHex() { const c = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique); return c ? c.color : '#353535'; },
      selectedApplique2Hex() { const c = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2); return c ? c.color : '#353535'; },
      selectedFabricName() { const c = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric); return c ? c.name : ''; },
      selectedEmbroideryName() { const c = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery); return c ? c.name : ''; },
      selectedEmbroidery2Name() { const c = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2); return c ? c.name : ''; },
      selectedAppliqueName() { const c = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique); return c ? c.name : ''; },
      selectedApplique2Name() { const c = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2); return c ? c.name : ''; },

      /* Monogram letter/detail colors default to whatever's closest to the product's
         (always-present) custom fabric/embroidery/appliqué color choice. */
      _recommendedMonogramColors() {
        const idx = this.monogramModal.productIdx;
        if (idx === null) return { letter: null, detail: null };
        const p = this.products[idx];
        if (!p || !p.customColorInfo) return { letter: null, detail: null };
        const info = p.customColorInfo;
        const resolve = id => this.monogramColors.find(c => c.id === id) || null;
        const embHex = info.embroideryColor || null;
        const appHex = info.appliqueColor || null;
        const fabHex = info.fabricColor || null;
        const letterHex = embHex || appHex || fabHex;
        const detailHex = appHex || embHex || fabHex;
        return {
          letter: letterHex ? resolve(this._closestMonogramColor(letterHex)) : null,
          detail: detailHex ? resolve(this._closestMonogramColor(detailHex)) : null,
        };
      },
      recommendedMonogramLetter() { return this._recommendedMonogramColors.letter; },
      recommendedMonogramDetail() { return this._recommendedMonogramColors.detail; },
      currentProduct() { return this.monogramModal.productIdx !== null ? this.products[this.monogramModal.productIdx] : null; },
      currentProductPositions() {
        const p = this.currentProduct;
        if (!p) return [];
        return this.monogramPositionImages.filter(pos => pos.product_type_id === p.typeNum);
      },
      monogramLibraryStyles() {
        let styles;
        if (this.monogramModal.activeTab === 'contemporary') styles = this.contemporaryStyles;
        else if (this.monogramModal.activeTab === 'children') styles = this.childrenStyles;
        else styles = this.classicStyles;
        const count = this.monogramModal.activeLetterCount;
        return (styles || []).filter(s => (s.max || 3) === count);
      },
      selectedMonogramStyle() {
        const id = this.monogramModal.selection.styleId;
        if (!id) return null;
        const allStyles = [...(this.classicStyles || []), ...(this.contemporaryStyles || []), ...(this.childrenStyles || []), ...(this.recommendedStyles || [])];
        return allStyles.find(s => s.id === id) || null;
      },
      currentMonogramMax() { return (this.selectedMonogramStyle && this.selectedMonogramStyle.max) || 3; },
      currentMonogramColorQty() { return (this.selectedMonogramStyle && this.selectedMonogramStyle.colorQty) || 2; },
      monogramPriceFormatted() { return formatPrice(this.monogramPriceCents, shopify.currency || 'EUR'); },
      monogramStep1Valid() { return !!this.monogramModal.selection.styleId; },
      monogramStep2Valid() { const l = this.monogramModal.selection.letters; return !!(l && l.length > 0); },
      monogramStep3Valid() { return !!this.monogramModal.selection.sleepingLetterColor; },
      monogramStep4Valid() { return !!this.monogramModal.selection.location; },
      monogramLetterColorName() { const c = this.monogramColors.find(c => c.id === this.monogramModal.selection.sleepingLetterColor); return c ? c.name : ''; },
      monogramDetailColorName() { const c = this.monogramColors.find(c => c.id === this.monogramModal.selection.sleepingDetailColor); return c ? c.name : ''; },
      colorModalSvg() {
        if (this.colorModal.productIdx === null) return null;
        return this.svgMain;
      },
    },

    watch: {
      'colorModal.selectedFabric': function () { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedEmbroidery': function () { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedEmbroidery2': function () { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedApplique': function () { this.$nextTick(() => this._applySvgColors()); },
      'colorModal.selectedApplique2': function () { this.$nextTick(() => this._applySvgColors()); },
      colorModalSvg: function () { this.$nextTick(() => this._applySvgColors()); },
      currentMonogramMax(max) {
        const letters = this.monogramModal.selection.letters;
        if (letters && letters.length > max) this.monogramModal.selection.letters = letters.slice(0, max);
      },
    },

    methods: {
      prevHero() { this.heroSlide = (this.heroSlide - 1 + this.heroImages.length) % this.heroImages.length; },
      nextHero() { this.heroSlide = (this.heroSlide + 1) % this.heroImages.length; },
      prevBundle() { this.bundleSlide = (this.bundleSlide - 1 + this.bundleImages.length) % this.bundleImages.length; },
      nextBundle() { this.bundleSlide = (this.bundleSlide + 1) % this.bundleImages.length; },
      prevAbout() { const n = shopify.aboutImageCount || 2; this.aboutSlide = (this.aboutSlide - 1 + n) % n; },
      nextAbout() { const n = shopify.aboutImageCount || 2; this.aboutSlide = (this.aboutSlide + 1) % n; },

      updateQty(idx, delta) {
        const p = this.products[idx];
        p.quantity = Math.max(1, p.quantity + delta);
        if (p.unitPriceCents != null) {
          p.price = formatPrice(p.unitPriceCents * p.quantity, shopify.currency || 'EUR');
        }
      },

      toggleMonogramCheck(idx) {
        const p = this.products[idx];
        if (!p.monogram) { p.monogram = true; this.openMonogramModal(idx); }
        else { p.monogram = false; p.monogramSelection = null; }
      },
      removeMonogram(idx) { this.products[idx].monogramSelection = null; this.products[idx].monogram = false; },

      /* Color Modal — always opens straight into the fabric/embroidery/appliqué pickers
         (no recommended-swatch step exists to skip past). Pre-fills from the product's
         current customColorInfo so editing starts from what's already selected. */
      openColorModal(idx) {
        const p = this.products[idx];
        const info = p.customColorInfo || {};
        const findByColor = (list, hex, fallback) => (list.find(c => c.color === hex) || list[0] || { id: fallback }).id;
        Object.assign(this.colorModal, {
          isOpen: true, productIdx: idx,
          selectedFabric: findByColor(this.fabricColors, info.fabricColor, 'f0'),
          selectedEmbroidery: this.embroidery_exists ? findByColor(this.embroideryColors, info.embroideryColor, 'e0') : 'e0',
          selectedEmbroidery2: this.embroidery2_exists ? findByColor(this.embroidery2Colors, info.embroidery2Color, 'e20') : 'e20',
          selectedApplique: this.applique_exists ? findByColor(this.appliqueColors, info.appliqueColor, 'a0') : 'a0',
          selectedApplique2: this.applique2_exists ? findByColor(this.applique2Colors, info.applique2Color, 'a20') : 'a20',
          showAllFabric: false, showAllEmbroidery: false, showAllEmbroidery2: false,
          showAllApplique: false, showAllApplique2: false,
        });
      },
      closeColorModal() { this.colorModal.isOpen = false; this.colorModal.productIdx = null; },
      applyColorSelection() {
        const idx = this.colorModal.productIdx;
        if (idx === null) return;
        const fabric = this.fabricColors.find(c => c.id === this.colorModal.selectedFabric);
        const emb = this.embroideryColors.find(c => c.id === this.colorModal.selectedEmbroidery);
        const emb2 = this.embroidery2Colors.find(c => c.id === this.colorModal.selectedEmbroidery2);
        const app = this.appliqueColors.find(c => c.id === this.colorModal.selectedApplique);
        const app2 = this.applique2Colors.find(c => c.id === this.colorModal.selectedApplique2);
        if (fabric) {
          const info = {
            fabricColor: fabric.color, fabricName: fabric.name,
            embroideryColor: this.embroidery_exists && emb ? emb.color : null,
            embroideryName: this.embroidery_exists && emb ? emb.name : null,
            embroidery2Color: this.embroidery2_exists && emb2 ? emb2.color : null,
            embroidery2Name: this.embroidery2_exists && emb2 ? emb2.name : null,
            appliqueColor: this.applique_exists && app ? app.color : null,
            appliqueName: this.applique_exists && app ? app.name : null,
            applique2Color: this.applique2_exists && app2 ? app2.color : null,
            applique2Name: this.applique2_exists && app2 ? app2.name : null,
          };
          if (this.isFirstSelection) {
            this.products.forEach(p => { p.customColorInfo = { ...info }; p.colorEdited = true; });
            this.isFirstSelection = false;
          } else {
            this.products[idx].customColorInfo = info;
            this.products[idx].colorEdited = true;
          }
        }
        this.closeColorModal();
      },

      /* Monogram Modal */
      _closestMonogramColor(hex) {
        if (!hex || !this.monogramColors.length) return 'ecru';
        const parse = h => {
          const s = h.replace('#', '');
          return [parseInt(s.slice(0, 2), 16) || 0, parseInt(s.slice(2, 4), 16) || 0, parseInt(s.slice(4, 6), 16) || 0];
        };
        const [r1, g1, b1] = parse(hex);
        let best = this.monogramColors[0];
        let bestDist = Infinity;
        this.monogramColors.forEach(mc => {
          const [r2, g2, b2] = parse(mc.color || '#000');
          const dist = Math.sqrt((r1 - r2) ** 2 + (g1 - g2) ** 2 + (b1 - b2) ** 2);
          if (dist < bestDist) { bestDist = dist; best = mc; }
        });
        return best.id;
      },

      /* Bath skips the "recommended colors, tap to customize" step entirely: the letter/detail
         colors are pre-set from the product's own custom color choice, and the monogram style
         defaults to the first of the same 4 recommended styles used on Bedding/Table Linens,
         so Step 1 already has a valid selection instead of starting empty. */
      openMonogramModal(idx) {
        const p = this.products[idx];
        let letterColor = 'ecru';
        let detailColor = 'ecru';
        if (!p.monogramSelection) {
          const info = p.customColorInfo || {};
          const embHex = info.embroideryColor || null;
          const appHex = info.appliqueColor || null;
          const fabHex = info.fabricColor || null;
          const lHex = embHex || appHex || fabHex;
          const dHex = appHex || embHex || fabHex;
          if (lHex) letterColor = this._closestMonogramColor(lHex);
          if (dHex) detailColor = this._closestMonogramColor(dHex);
        }
        Object.assign(this.monogramModal, {
          isOpen: true, productIdx: idx, currentStep: 1,
          showAllStyles: false, activeTab: 'classic', activeLetterCount: 1,
          hoveredStyleId: null, showAllLetterColors: false, showAllDetailColors: false,
        });
        const defaultStyle = (this.recommendedStyles && this.recommendedStyles[0]) || null;
        this.monogramModal.selection = p.monogramSelection
          ? { ...p.monogramSelection }
          : {
              styleId: defaultStyle ? defaultStyle.id : null,
              styleName: defaultStyle ? defaultStyle.name : '',
              styleImage: defaultStyle ? (defaultStyle.image || '') : '',
              styleHoverImage: defaultStyle ? (defaultStyle.hoverImage || defaultStyle.image || '') : '',
              stylePlaceholder: defaultStyle ? (defaultStyle.placeholder || '') : '',
              letters: '', sleepingLetterColor: letterColor, sleepingDetailColor: detailColor, location: '',
            };
      },
      closeMonogramModal() {
        const idx = this.monogramModal.productIdx;
        if (idx !== null && !this.products[idx].monogramSelection) this.products[idx].monogram = false;
        this.monogramModal.isOpen = false;
        this.monogramModal.productIdx = null;
      },
      selectMonogramStyle(style) {
        Object.assign(this.monogramModal.selection, { styleId: style.id, styleName: style.name, styleImage: style.image || '', styleHoverImage: style.hoverImage || style.image || '', stylePlaceholder: style.placeholder || '' });
      },
      monoNext() {
        if (this.monogramModal.currentStep === 1 && !this.monogramStep1Valid) return;
        if (this.monogramModal.currentStep === 2 && !this.monogramStep2Valid) return;
        if (this.monogramModal.currentStep === 3 && !this.monogramStep3Valid) return;
        if (this.monogramModal.currentStep < 4) this.monogramModal.currentStep++;
      },
      monoPrev() { if (this.monogramModal.currentStep > 1) this.monogramModal.currentStep--; },
      completeMonogram() {
        const idx = this.monogramModal.productIdx;
        if (idx === null || !this.monogramStep4Valid) return;
        this.products[idx].monogramSelection = { ...this.monogramModal.selection };
        this.products[idx].monogram = true;
        this.monogramModal.isOpen = false;
        this.monogramModal.productIdx = null;
      },
      updateMonogramLetters(e) { this.monogramModal.selection.letters = e.target.value.toUpperCase().slice(0, this.currentMonogramMax); },
      selectMonogramLocation(loc) { this.monogramModal.selection.location = loc; },

      /* Fabric/Size dropdown sync — Fabric Type only renders on the card when a product
         actually has more than one fabric option (see the liquid template). */
      syncPrice(idx) {
        const p = this.products[idx];
        if (!Array.isArray(p.variantData) || !p.variantData.length) return;
        const matches = p.variantData.filter(v => {
          const fVal = p.fabricOptIdx >= 0 ? getVariantOptionVal(v, p.fabricOptIdx) : null;
          const sVal = p.sizeOptIdx >= 0 ? getVariantOptionVal(v, p.sizeOptIdx) : null;
          const fabricOk = !fVal || !p.fabricType || fVal.toLowerCase() === p.fabricType.toLowerCase();
          const sizeOk = !sVal || sVal === p.size;
          return fabricOk && sizeOk;
        });
        const match = matches.find(v => v.available) || matches[0] || null;
        if (match) {
          p.unitPriceCents = match.price;
          p.price = formatPrice(match.price * (p.quantity || 1), shopify.currency || 'EUR');
          p.variantId = match.id;
          p.variantAvailable = match.available;
        }
      },

      /* ── Build cart line items for a product (shared by confirm + submit) ── */
      _buildLineItems(p) {
        const randNum = Math.floor(Math.random() * 100000);
        const items = [];

        const info = p.customColorInfo || {};
        const fabricColor = info.fabricName ? info.fabricName + ' Fabric' : '';
        const embColor = info.embroideryColor ? info.embroideryName + ' ' + (shopify.embroideryLabel || 'Embroidery') : '';
        const emb2Color = info.embroidery2Color ? info.embroidery2Name + ' ' + (shopify.embroidery2Label || 'Secondary Embroidery') : '';
        const appColor = info.appliqueColor ? info.appliqueName + ' ' + (shopify.appliqueLabel || 'Appliqué') : '';
        const app2Color = info.applique2Color ? info.applique2Name + ' ' + (shopify.applique2Label || 'Second Appliqué') : '';

        const colorProps = { 'Fabric Color': fabricColor, 'Appliqué Color': appColor, 'Second Appliqué Color': app2Color, 'Embroidery Color': embColor, 'Second Embroidery Color': emb2Color };

        const bid = 'b_' + randNum + '_' + (p.variantId || '');

        if (p.monogram && p.monogramSelection && p.monogramSelection.letters) {
          const sel = p.monogramSelection;
          const letterColorObj = this.monogramColors.find(c => c.id === sel.sleepingLetterColor);
          const detailColorObj = this.monogramColors.find(c => c.id === sel.sleepingDetailColor);
          const allStyles = [...(this.classicStyles || []), ...(this.contemporaryStyles || []), ...(this.childrenStyles || []), ...(this.recommendedStyles || [])];
          const selStyle = allStyles.find(s => s.id === sel.styleId);
          const styleColorQty = (selStyle && selStyle.colorQty) || 2;
          const monoProps = {
            ...colorProps,
            'Monogram Alphabet': sel.styleName || '', 'Monogram Letters': sel.letters,
            'Monogram Letter Color': letterColorObj ? letterColorObj.name : '',
            'Monogram Position': sel.location || '',
            '_type': 'Master', '_bid': bid,
          };
          if (styleColorQty >= 2) monoProps['Monogram Detail Color'] = detailColorObj ? detailColorObj.name : '';
          items.push({ id: p.variantId, quantity: p.quantity, properties: monoProps });
          const monoVariantId = p.monogramVariantId || monogramDefaultVariantId || null;
          if (monoVariantId) items.push({ id: monoVariantId, quantity: p.quantity, properties: { '_type': 'Child', '_bid': bid } });
        } else {
          items.push({ id: p.variantId, quantity: p.quantity, properties: { ...colorProps } });
        }

        const extraProps = {};
        if (p.initials) extraProps['Initials'] = p.initials;
        if (p.initial) extraProps['Initial'] = p.initial;
        if (p.customRequest) extraProps['Custom Request'] = p.customRequest;
        if (p.bdayName) extraProps['Birthday Name'] = p.bdayName;
        if (p.bdayDay) extraProps['Birthday Day'] = p.bdayDay;
        if (p.bdayMonth) extraProps['Birthday Month'] = p.bdayMonth;
        if (p.bdayYear) extraProps['Birthday Year'] = p.bdayYear;
        if (Object.keys(extraProps).length) items.forEach(item => Object.assign(item.properties, extraProps));

        return items;
      },

      /* ── Confirm Selection — local only, no network call ─────── */
      addToCart(idx) {
        const p = this.products[idx];
        if (!p || !p.variantId || !p.colorChosen) return;
        if (p.variantAvailable === false) { alert('Sorry, this size is currently out of stock.'); return; }

        const cur = shopify.currency || 'EUR';
        const monoQty = (p.monogram && p.monogramSelection) ? p.quantity : 0;
        const lineCents = (p.unitPriceCents || 0) * p.quantity + this.monogramPriceCents * monoQty;

        const variantLabel = [p.fabricType, p.size].filter(Boolean).join(' · ');

        const newItem = {
          _variantId: p.variantId, _lineCents: lineCents, _lineItems: this._buildLineItems(p),
          title: p.title, variantTitle: variantLabel, quantity: p.quantity,
          price: formatPrice(lineCents, cur), image: p.image || '',
          monogram: p.monogramSelection ? p.monogramSelection.letters : null,
          styleName: p.monogramSelection ? p.monogramSelection.styleName : null,
        };

        const updatedItems = [...this.cartDrawer.items];
        const existing = updatedItems.findIndex(i => i._variantId === p.variantId);
        if (existing >= 0) {
          this._cartTotalCents = ((this._cartTotalCents || 0) - updatedItems[existing]._lineCents) + lineCents;
          updatedItems[existing] = newItem;
        } else {
          this._cartTotalCents = (this._cartTotalCents || 0) + lineCents;
          updatedItems.push(newItem);
        }

        this.cartDrawer = {
          isOpen: true, loading: false, items: updatedItems,
          itemCount: updatedItems.reduce((n, i) => n + i.quantity, 0),
          total: formatPrice(this._cartTotalCents, cur),
        };
      },

      /* ── Submit all confirmed items to Shopify, then go to cart ─ */
      submitCart() {
        if (!this.cartDrawer.items.length) return;

        const unavailable = this.cartDrawer.items.filter(i => {
          const p = this.products.find(prod => prod.variantId === i._variantId);
          return p && p.variantAvailable === false;
        });
        if (unavailable.length) {
          alert('Some items in your bag are out of stock: ' + unavailable.map(i => i.title).join(', ') + '. Please update your selection.');
          return;
        }

        this.cartDrawer.loading = true;
        const allItems = this.cartDrawer.items.flatMap(i => i._lineItems);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            window.location.href = '/cart';
          } else {
            this.cartDrawer.loading = false;
            alert('Could not submit your bag. Please try again.');
          }
        };
        xhr.onerror = () => {
          this.cartDrawer.loading = false;
          alert('Could not submit your bag. Please try again.');
        };
        xhr.send(JSON.stringify({ items: allItems }));
      },

      _applySvgColors() {
        const el = document.querySelector('.jb-svg-preview svg');
        if (!el) return;
        const set = (id, color) => { const node = el.querySelector('#' + id); if (node) node.style.fill = color; };
        set('Fabric', this.selectedFabricHex);
        set('Lines', this.selectedFabricHex);
        set('Embroidery', this.selectedEmbroideryHex);
        set('Embroidery2', this.selectedEmbroidery2Hex);
        set('Applique', this.selectedAppliqueHex);
        set('Applique2', this.selectedApplique2Hex);
      },
    },

    mounted() {
      const fetchSvg = (url) => url
        ? fetch(url).then(r => r.ok ? r.text() : null).catch(e => { console.warn('[JB] SVG fetch failed:', url, e); return null; })
        : Promise.resolve(null);

      fetchSvg(shopify.svgMainUrl).then((main) => { if (main) this.svgMain = main; });

      this.$nextTick(() => {
        const sentinel = document.getElementById('jb-main-sentinel');
        const leftEl = document.getElementById('jb-left-panel');
        if (!sentinel || !leftEl) return;

        var triggerY = sentinel.getBoundingClientRect().top + window.scrollY;

        function updateSticky() {
          leftEl.classList.toggle('is-sticky', window.scrollY >= triggerY);
        }

        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', function () {
          leftEl.classList.remove('is-sticky');
          triggerY = sentinel.getBoundingClientRect().top + window.scrollY;
          updateSticky();
        }, { passive: true });

        updateSticky();
      });
    },
  });

  app.mount('#jb-app');
})();
